import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout
} from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useErrorToast } from '../../lib/useErrorToast';
import { useCheckout } from './useCheckout';

const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string
);

export default function CheckoutForm() {
  const checkoutQuery = useCheckout();

  const clientSecret = checkoutQuery.data?.client_secret;

  useErrorToast(checkoutQuery.error);

  useEffect(() => {
    if (
      checkoutQuery.data &&
      !checkoutQuery.isLoading &&
      !checkoutQuery.data.client_secret
    ) {
      console.error('No client secret found');
      toast.error('No client secret found for checkout');
    }
  }, [checkoutQuery.data]);

  if (!clientSecret) {
    return null;
  }

  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}
